import { render, staticRenderFns } from "./livebackIndex.vue?vue&type=template&id=49c774e3&scoped=true&"
import script from "./livebackIndex.vue?vue&type=script&lang=js&"
export * from "./livebackIndex.vue?vue&type=script&lang=js&"
import style0 from "./livebackIndex.vue?vue&type=style&index=0&id=49c774e3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c774e3",
  null
  
)

export default component.exports